import { Tooltip } from 'antd'
import React, { ReactNode } from 'react'

export const OverflowTooltip = ({ width, children, title }: { width: number, children: ReactNode, title?: string | ReactNode}) =>
  <span className="table-name w-100">
    <Tooltip title={title || children} destroyTooltipOnHide={{ keepParent: false }}>
      <span className='overflow-ellipsis overflow-tooltip' style={{ width }}>{children}</span>
    </Tooltip>
  </span>
